import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./reducers/auth";
import NotificationReducer from "./reducers/notification";
import UsersReducer from "./reducers/users";
import RdpsReducer from "./reducers/rdps";
import ActivitiesReducer from "./reducers/activities";
import ServerData from './reducers/server';
import ServerTypeData from './reducers/serverType';
import RemoteControlData from './reducers/RemoteControl';
import DataCenterData from './reducers/DataCenter';
import RemotePanelData from './reducers/RemotePanel';
const store = configureStore({
  reducer: {
    auth: AuthReducer,
    notifications: NotificationReducer,
    users: UsersReducer,
    rdps: RdpsReducer,
    activities: ActivitiesReducer,
    server:ServerData,
    serverType:ServerTypeData,
    RemoteControl:RemoteControlData,
    DataCenter:DataCenterData,
    RemotePanel:RemotePanelData,
  },
});

export default store;
